import {
    Box, Button,
    Typography,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton,
    FormHelperText
} from '@mui/material';
import { LANG } from '../../language/lang';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux'
import { useState, useEffect } from 'react';
import { useInput } from '../../utils/hooks';
import { clearErrors, handleLogin } from '../../store/slice/userSlice'

const LoginBox = ({ isMobile, toggleAuthMode, onSuccess }) => {

    const dispatch = useDispatch()
    const { errors, globalError, isLoading } = useSelector(state => state.user)
    const login = useInput('', { isEmpty: true })
    const password = useInput('', { isEmpty: true, minLength: 8 })
    const [showPassword, setShowPassword] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)

    useEffect(() => {
        if (isSubmitted && !isLoading && Object.keys(errors).length === 0 && !globalError) {
            setIsSubmitted(false)
            onSuccess()
        }
    }, [isSubmitted, isLoading, errors, globalError, onSuccess])

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = () => {
        setIsSubmitted(true)
        dispatch(handleLogin({ login: login.value, password: password.value }))
    }


    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width='100%'
                gap={2}
            >
                <Typography variant={isMobile ? 'h6' : 'h5'} fontWeight={600} textAlign="center">
                    {LANG("LOGIN_TITLE")}
                </Typography>
                {globalError && <Typography sx={{ textAlign: 'center', width: '100%', display: 'block' }} variant="caption" color={"red"}>{globalError.message}</Typography>}


                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-login">{LANG('TEXT_LABEL_LOGIN')}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-login"
                        label={LANG('TEXT_LABEL_LOGIN')}
                        onChange={e => {
                            if (errors?.login) {
                                dispatch(clearErrors())
                            }
                            login.onChange(e)
                        }}
                        onBlur={e => login.onBlur(e)}
                        value={login.value}
                        error={!!errors?.login || !!login.getError()}
                    />
                    {login.getError() && <FormHelperText sx={{ maxWidth: '300px' }} error>{login.getError()}</FormHelperText>}
                    {errors?.login && <FormHelperText sx={{ maxWidth: '300px' }} error>{errors?.login.message}</FormHelperText>}
                </FormControl>

                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">{LANG('TEXT_LABEL_PASSWORD')}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        label={LANG('TEXT_LABEL_PASSWORD')}
                        value={password.value}
                        error={!!password.getError() || (password.isDirty && password.minLength && password.value.length > 0)}
                        onBlur={e => password.onBlur(e)}
                        onChange={
                            (e) => password.onChange(e)
                        }
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label={
                                        showPassword ? 'hide the password' : 'display the password'
                                    }
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    onMouseUp={handleMouseUpPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }

                    />
                    {password.getError() && <FormHelperText sx={{ maxWidth: '300px' }} error>{password.getError()}</FormHelperText>}
                    {errors?.password && <FormHelperText sx={{ maxWidth: '300px' }} error>{errors?.password.message}</FormHelperText>}

                </FormControl>

                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                    mt={2}
                >
                    <Button variant="contained" fullWidth onClick={handleSubmit}>{LANG('BTN_LOGIN')}</Button>

                    <Button variant="text" onClick={toggleAuthMode}>
                        {LANG('TEXT_LABEL_NO_ACCOUNT')} {LANG('BTN_REGISTER')}
                    </Button>
                </Box>

            </Box>
        </>
    );
};

export default LoginBox;